<aside class="h-full bg-white shadow-md relative overflow-y-auto overflow-x-hidden"
  [ngClass]="{ 'w-[315px]': !isMinimized, 'w-[90px]': isMinimized }">
  <!-- toggle button -->

  <div
    class="absolute -right-1 text-indigo-500 top-2 bg-[#f5f5f9] rounded-full p-1.5 hover:text-indigo-400 cursor-pointer"
    (click)="toggleSideBar()">
    <svg xmlns="http://www.w3.org/2000/svg" height="25" class="transform duration-100 delay-75"
      [ngClass]="{ 'rotate-180': isMinimized }" width="25" viewBox="0 0 512 512">
      <path fill="currentColor"
        d="M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM271 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L167 273c-9.4-9.4-9.4-24.6 0-33.9L271 135z" />
    </svg>
  </div>

  <!-- logo -->

  <div class="w-full h-54 flex items-center justify-start px-3">
    @if (isMinimized) {
    <div class="w-full overflow-x-hidden mt-3 scale-[.75]">
      <svg xmlns="http://www.w3.org/2000/svg" id="logo-dc" class=" " width="218.632" height="65"
        viewBox="0 0 218.632 65">
        <g id="Layer_2" data-name="Layer 2">
          <g id="Logo">
            <path id="Path_233" data-name="Path 233"
              d="M54.687,27.344A.342.342,0,0,0,54.345,27H51.268C29.737,27,27.687,24.951,27.687,3.42V.342A.34.34,0,0,0,27.346,0h0A.342.342,0,0,0,27,.342V3.419C27,24.95,24.951,27,3.42,27H.343A.341.341,0,0,0,0,27.34v0H0a.342.342,0,0,0,.342.342H3.419C24.95,27.686,27,29.736,27,51.267v3.077a.341.341,0,0,0,.34.343h0a.342.342,0,0,0,.342-.342V51.267c0-21.531,2.05-23.581,23.581-23.581h3.077a.341.341,0,0,0,.343-.34v0Z"
              fill="#9cf" />
          </g>
        </g>
      </svg>
    </div>
    } @else {
    <div class="w-[150px] px-2">
      <svg xmlns="http://www.w3.org/2000/svg" id="logo-dc" class="w-full" width="218.632" height="65"
        viewBox="0 0 218.632 79.999">
        <g id="Group_156" data-name="Group 156" transform="translate(49.603 44.006)">
          <path id="Path_223" data-name="Path 223"
            d="M55.153,63.6H53.372V60.164h-.127a6.62,6.62,0,0,1-6.1,3.943c-3.688,0-8.14-2.162-8.14-10.048,0-6.486,3.18-10.175,8.14-10.175,2.925,0,5.087,1.4,5.978,3.816h.127V34.6h1.908ZM53.245,52.024c0-3.18-2.035-6.486-5.978-6.486-4.324,0-6.359,3.688-6.359,8.394,0,5.087,1.908,8.521,6.232,8.521s6.1-3.561,6.1-6.614Z"
            transform="translate(-39 -34.6)" fill="#404040" />
          <path id="Path_224" data-name="Path 224"
            d="M63.894,62.022c-5.851,0-8.394-3.688-8.394-9.92,0-5.851,2.925-10.3,8.267-10.3,5.6,0,7.377,4.579,7.377,8.9v1.526H57.408c.127,5.087,2.035,8.14,6.486,8.14a5.544,5.544,0,0,0,5.215-3.434h1.781C70.253,59.733,67.71,62.022,63.894,62.022ZM69.363,50.7c0-2.8-.89-7.25-5.469-7.25-3.943,0-5.978,3.052-6.359,7.377H69.363Z"
            transform="translate(-34.514 -32.643)" fill="#404040" />
          <path id="Path_225" data-name="Path 225"
            d="M84.064,49.25a6.859,6.859,0,0,0-1.017-4.2c-.636-.89-1.653-1.4-3.434-1.4-4.2,0-6.1,3.434-6.1,6.741V61.587H71.6v-19.2h1.781v3.561h.127A6.667,6.667,0,0,1,79.994,42c4.579,0,5.978,2.671,5.978,6.868V61.587H84.064Z"
            transform="translate(-30.138 -32.588)" fill="#404040" />
          <path id="Path_226" data-name="Path 226"
            d="M91.551,37.7v5.851h5.087v1.526H91.551V58.3c0,2.035.89,3.052,3.18,3.052A10.5,10.5,0,0,0,97.02,61.1v1.653a10.776,10.776,0,0,1-2.671.254c-3.688,0-4.833-2.035-4.833-4.579V45.077H85.7V43.551h1.017c2.289,0,2.8-.382,2.8-3.816V37.7Z"
            transform="translate(-26.304 -33.757)" fill="#404040" />
          <path id="Path_227" data-name="Path 227"
            d="M97.59,47.369c0-2.925,2.544-5.469,6.741-5.469,5.723,0,6.614,3.688,6.614,7v8.776c0,1.908.636,2.671,1.908,2.671v1.526H112.6c-2.417,0-3.434-1.272-3.434-4.07h-.127a7.1,7.1,0,0,1-6.614,4.2c-3.434,0-5.723-1.908-5.723-5.342a5.052,5.052,0,0,1,2.417-4.579c1.781-1.017,5.087-1.4,10.048-1.781V48.768c0-2.671-.763-5.342-4.833-5.342-3.052,0-4.706,1.653-4.833,3.816H97.59Zm11.447,5.6V51.82c-5.215.382-7.758.636-8.9,1.526a3.55,3.55,0,0,0-1.526,3.18c0,2.544,1.781,3.816,4.2,3.816C105.73,60.215,109.037,57.671,109.037,52.965Z"
            transform="translate(-23.314 -32.615)" fill="#404040" />
          <path id="Path_228" data-name="Path 228" d="M112.5,34.6h1.908v29H112.5Z" transform="translate(-19.019 -34.6)"
            fill="#404040" />
          <path id="Path_229" data-name="Path 229"
            d="M131.482,47.369c-.254-1.908-1.908-3.816-5.087-3.816-3.943,0-6.359,3.052-6.359,8.394s1.908,8.521,6.232,8.521c3.561,0,4.706-2.162,5.342-4.451h1.908c-.636,4.07-3.434,6.1-7.25,6.1-5.6,0-8.267-3.943-8.267-9.92,0-5.851,3.052-10.3,8.394-10.3,3.18,0,6.614,1.526,7.122,5.469Z"
            transform="translate(-17.524 -32.615)" fill="#404040" />
          <path id="Path_230" data-name="Path 230"
            d="M132.7,51.948c0-5.6,2.925-10.048,8.267-10.048,5.851,0,8.14,4.451,8.14,10.048,0,5.851-2.8,10.048-8.14,10.048C135.117,62,132.7,57.8,132.7,51.948Zm1.908,0c0,5.087,2.035,8.521,6.232,8.521,4.07,0,6.232-3.307,6.232-8.521,0-5.087-1.908-8.521-6.232-8.521C136.9,43.426,134.608,46.86,134.608,51.948Z"
            transform="translate(-13.527 -32.615)" fill="#404040" />
          <path id="Path_231" data-name="Path 231"
            d="M149.4,42.382h1.781v4.324h.127A6.437,6.437,0,0,1,157.286,42h.382v1.781h-.382c-2.671,0-5.851,1.908-5.851,7.122V61.459h-1.908V42.382Z"
            transform="translate(-8.987 -32.588)" fill="#404040" />
          <path id="Path_232" data-name="Path 232"
            d="M159.1,42.409h1.781V45.97h.127a6.867,6.867,0,0,1,6.614-4.07c3.943,0,7.758,2.417,7.758,9.92,0,7-3.816,10.3-8.267,10.3a6.485,6.485,0,0,1-5.978-3.943h-.127V68.609H159.1Zm7.885,18.06c4.07,0,6.232-3.561,6.232-8.649,0-4.579-1.526-8.267-6.1-8.267-4.2,0-6.232,3.307-6.232,6.741V53.6C161.008,56.781,162.788,60.469,166.985,60.469Z"
            transform="translate(-6.35 -32.615)" fill="#404040" />
        </g>
        <g id="Layer_2" data-name="Layer 2">
          <g id="Logo">
            <path id="Path_233" data-name="Path 233"
              d="M54.687,27.344A.342.342,0,0,0,54.345,27H51.268C29.737,27,27.687,24.951,27.687,3.42V.342A.34.34,0,0,0,27.346,0h0A.342.342,0,0,0,27,.342V3.419C27,24.95,24.951,27,3.42,27H.343A.341.341,0,0,0,0,27.34v0H0a.342.342,0,0,0,.342.342H3.419C24.95,27.686,27,29.736,27,51.267v3.077a.341.341,0,0,0,.34.343h0a.342.342,0,0,0,.342-.342V51.267c0-21.531,2.05-23.581,23.581-23.581h3.077a.341.341,0,0,0,.343-.34v0Z"
              fill="#9cf" />
          </g>
        </g>
      </svg>
    </div>
    <div class="flex items-end h-full text-xl text-indigo-500">
      {{ environment }}
    </div>
    }
  </div>

  <!-- Home  -->
  <div class="flex flex-col justify-start items-center px-3 pb-2 w-full text-gray-600"
    [ngClass]="isMinimized ? 'pl-3 items-center' : 'pl-6'">
    <button (click)="toggleHomeMenu()"
      class="group relative focus:outline-none focus:text-indigo-500 hover:text-indigo-500 text-left text-gray-600 flex items-center w-full py-t-3 gap-2"
      [ngClass]="{ 'justify-center': isMinimized, 'justify-between': !isMinimized }" [routerLink]="['/dashboard']"
      routerLinkActive="router-link-active">
      <span class="flex gap-3 items-center relative">
        <svg xmlns="http://www.w3.org/2000/svg" height="16.2" width="16.5" fill="currentColor" viewBox="0 0 576 512">
          <path
            d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z" />
        </svg>
        <p class="text-base header-font leading-5" [ngClass]="{ hidden: isMinimized }">
          Home
        </p>
        <div class="hidden absolute left-0 -top-10 w-[100px] justify-center z-20"
          [ngClass]="{ 'group-hover:flex': isMinimized }">
          <div class="bg-[#00000079] text-white w-fit header-font rounded py-1 px-4">
            Home
          </div>
        </div>
      </span>
    </button>
    <div id="menu1" class="flex justify-start flex-col w-full md:w-auto items-start pb-1"></div>
  </div>

  <!-- Configuration Menu-->

  <div class="flex flex-col justify-start px-3 pb-2 w-full text-gray-600" [ngClass]="{ 'items-center': isMinimized }">
    <div class="relative group">
      <button
        class="overflow-hidden hover:bg-gray-100 focus:bg-gray-100 px-3 focus:outline-none text-left flex min-w-0 w-full justify-between items-center py-2 gap-2"
        [ngClass]="{
          '!text-indigo-500 !bg-indigo-100': activeRoute[1] == 'configuration',
          'w-fit': isMinimized,
          'w-full': !isMinimized
        }" (click)="toggleConfigurationMenu()">
        <span class="flex items-center gap-3 min-w-0">
          <svg xmlns="http://www.w3.org/2000/svg" height="16.2" width="16.5" fill="currentColor" viewBox="0 0 640 512">
            <path
              d="M308.5 135.3c7.1-6.3 9.9-16.2 6.2-25c-2.3-5.3-4.8-10.5-7.6-15.5L304 89.4c-3-5-6.3-9.9-9.8-14.6c-5.7-7.6-15.7-10.1-24.7-7.1l-28.2 9.3c-10.7-8.8-23-16-36.2-20.9L199 27.1c-1.9-9.3-9.1-16.7-18.5-17.8C173.9 8.4 167.2 8 160.4 8h-.7c-6.8 0-13.5 .4-20.1 1.2c-9.4 1.1-16.6 8.6-18.5 17.8L115 56.1c-13.3 5-25.5 12.1-36.2 20.9L50.5 67.8c-9-3-19-.5-24.7 7.1c-3.5 4.7-6.8 9.6-9.9 14.6l-3 5.3c-2.8 5-5.3 10.2-7.6 15.6c-3.7 8.7-.9 18.6 6.2 25l22.2 19.8C32.6 161.9 32 168.9 32 176s.6 14.1 1.7 20.9L11.5 216.7c-7.1 6.3-9.9 16.2-6.2 25c2.3 5.3 4.8 10.5 7.6 15.6l3 5.2c3 5.1 6.3 9.9 9.9 14.6c5.7 7.6 15.7 10.1 24.7 7.1l28.2-9.3c10.7 8.8 23 16 36.2 20.9l6.1 29.1c1.9 9.3 9.1 16.7 18.5 17.8c6.7 .8 13.5 1.2 20.4 1.2s13.7-.4 20.4-1.2c9.4-1.1 16.6-8.6 18.5-17.8l6.1-29.1c13.3-5 25.5-12.1 36.2-20.9l28.2 9.3c9 3 19 .5 24.7-7.1c3.5-4.7 6.8-9.5 9.8-14.6l3.1-5.4c2.8-5 5.3-10.2 7.6-15.5c3.7-8.7 .9-18.6-6.2-25l-22.2-19.8c1.1-6.8 1.7-13.8 1.7-20.9s-.6-14.1-1.7-20.9l22.2-19.8zM112 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM504.7 500.5c6.3 7.1 16.2 9.9 25 6.2c5.3-2.3 10.5-4.8 15.5-7.6l5.4-3.1c5-3 9.9-6.3 14.6-9.8c7.6-5.7 10.1-15.7 7.1-24.7l-9.3-28.2c8.8-10.7 16-23 20.9-36.2l29.1-6.1c9.3-1.9 16.7-9.1 17.8-18.5c.8-6.7 1.2-13.5 1.2-20.4s-.4-13.7-1.2-20.4c-1.1-9.4-8.6-16.6-17.8-18.5L583.9 307c-5-13.3-12.1-25.5-20.9-36.2l9.3-28.2c3-9 .5-19-7.1-24.7c-4.7-3.5-9.6-6.8-14.6-9.9l-5.3-3c-5-2.8-10.2-5.3-15.6-7.6c-8.7-3.7-18.6-.9-25 6.2l-19.8 22.2c-6.8-1.1-13.8-1.7-20.9-1.7s-14.1 .6-20.9 1.7l-19.8-22.2c-6.3-7.1-16.2-9.9-25-6.2c-5.3 2.3-10.5 4.8-15.6 7.6l-5.2 3c-5.1 3-9.9 6.3-14.6 9.9c-7.6 5.7-10.1 15.7-7.1 24.7l9.3 28.2c-8.8 10.7-16 23-20.9 36.2L315.1 313c-9.3 1.9-16.7 9.1-17.8 18.5c-.8 6.7-1.2 13.5-1.2 20.4s.4 13.7 1.2 20.4c1.1 9.4 8.6 16.6 17.8 18.5l29.1 6.1c5 13.3 12.1 25.5 20.9 36.2l-9.3 28.2c-3 9-.5 19 7.1 24.7c4.7 3.5 9.5 6.8 14.6 9.8l5.4 3.1c5 2.8 10.2 5.3 15.5 7.6c8.7 3.7 18.6 .9 25-6.2l19.8-22.2c6.8 1.1 13.8 1.7 20.9 1.7s14.1-.6 20.9-1.7l19.8 22.2zM464 304a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
              stroke="currentColor" stroke-width="1.5" />
          </svg>
          <p class="text-base header-font leading-5" [ngClass]="{ hidden: isMinimized }">
            Configuration
          </p>
        </span>
        <svg id="icon1" class="transform" [ngClass]="{ 'rotate-180': !configurationMenu, hidden: isMinimized }"
          width="16.5" height="16.2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 15L12 9L6 15" stroke="currentColor" stroke-width="3" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
      <!-- Tooltip for Configuration -->
      <div
        class="hidden absolute -left-2 -top-5 w-[100px] justify-center transition-opacity duration-700 ease-in-out opacity z-20"
        [ngClass]="{ 'group-hover:flex': isMinimized }">
        <div class="bg-[#00000079] text-white w-fit header-font rounded py-1 px-4 right-0 bottom-full">
          Configuration
          <svg class="absolute text-[#00000079] h-2 left-0 ml-3 top-full" x="0px" y="0px" viewBox="0 0 255 255"
            xml:space="preserve"></svg>
        </div>
      </div>
    </div>
    <div id="menu1" class="flex w-full min-w-0 flex-col pt-1 text-gray-600"
      [class]="configurationMenu ? 'flex' : 'hidden'"
      [ngClass]="{ 'items-center': isMinimized,'pl-0': isMinimized, 'pl-6 ':!isMinimized, 'w-[60%]': isMinimized ,}">
      <button [routerLink]="['/dashboard/configuration/pms']" routerLinkActive="router-link-active"
        class="group relative w-fit focus:outline-none flex justify-start hover:text-indigo-500 focus:text-indigo-500 rounded py-2"
        [ngClass]="{ 'text-indigo-500': activeRoute[2] === 'pms', 'justify-center': isMinimized }">
        <!-- tooltip for minimized part -->

        <div
          class="hidden absolute -left-2 -top-5 w-[100px] justify-center transition-opacity duration-700 ease-in-out opacity z-20"
          [ngClass]="{ 'group-hover:flex': isMinimized }">
          <div class="bg-[#00000079] text-white w-fit header-font rounded py-1 px-4 right-0 bottom-full">
            PMS
            <svg class="absolute text-[#00000079] h-2 left-0 ml-3 top-full" x="0px" y="0px" viewBox="0 0 255 255"
              xml:space="preserve"></svg>
          </div>
        </div>
        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="16.2" fill="currentColor"  viewBox="0 0 448 512"> 
          <path d="M186.1 52.1C169.3 39.1 148.7 32 127.5 32C74.7 32 32 74.7 32 127.5v6.2c0 15.8 3.7 31.3 10.7 45.5l23.5 47.1c4.5 8.9 7.6 18.4 9.4 28.2l36.7 205.8c2 11.2 11.6 19.4 22.9 19.8s21.4-7.4 24-18.4l28.9-121.3C192.2 323.7 207 312 224 312s31.8 11.7 35.8 28.3l28.9 121.3c2.6 11.1 12.7 18.8 24 18.4s20.9-8.6 22.9-19.8l36.7-205.8c1.8-9.8 4.9-19.3 9.4-28.2l23.5-47.1c7.1-14.1 10.7-29.7 10.7-45.5v-2.1c0-55-44.6-99.6-99.6-99.6c-24.1 0-47.4 8.8-65.6 24.6l-3.2 2.8 19.5 15.2c7 5.4 8.2 15.5 2.8 22.5s-15.5 8.2-22.5 2.8l-24.4-19-37-28.8z"/></svg> -->
        <svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="16.2" fill="currentColor" viewBox="0 0 512 512">
          <path
            d="M284.3 11.7c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216z" />
        </svg>
        <p class="text-base header-font leading-4 pl-3" [ngClass]="{ hidden: isMinimized }">
          PMS
        </p>
      </button>

      <button
        class="group relative focus:outline-none flex w-full min-w-0 justify-start hover:text-indigo-500 focus:text-indigo-500 rounded py-2"
        [routerLink]="['/dashboard/configuration/practices']" routerLinkActive="router-link-active"
        [ngClass]="{ 'text-indigo-500': activeRoute[2] === 'practices', 'justify-center': isMinimized }">
        <div class="hidden absolute -left-12 -top-5 w-[200px] justify-center z-20"
          [ngClass]="{ 'group-hover:flex': isMinimized }">
          <div class="bg-[#00000079] text-white w-fit header-font rounded py-1 px-4 right-0 bottom-full">
            Practices
            <svg class="absolute text-[#00000079] h-2 left-0 ml-3 top-full" x="0px" y="0px" viewBox="0 0 255 255"
              xml:space="preserve"></svg>
          </div>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="16.2" fill="currentColor" viewBox="0 0 576 512">
          <path
            d="M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM256 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V320H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z" />
        </svg>

        <p class="text-base header-font text-ellipsis leading-4 pl-3 z-10" [ngClass]="{ hidden: isMinimized }">
          Practices
        </p>
      </button>

      <button
        class="group relative focus:outline-none flex w-full min-w-0 justify-start hover:text-indigo-500 focus:text-indigo-500 rounded py-2"
        [routerLink]="['/dashboard/configuration/practice-operational-hours']" routerLinkActive="router-link-active"
        [ngClass]="{ 'text-indigo-500': activeRoute[2] === 'practice-operational-hours', 'justify-center': isMinimized }">
        <div class="hidden absolute -left-12 -top-5 w-[200px] justify-center z-20"
          [ngClass]="{ 'group-hover:flex': isMinimized }">
          <div class="bg-[#00000079] text-white w-fit header-font rounded py-1 px-4 right-0 bottom-full">
            Practice Operational Hours
            <svg class="absolute text-[#00000079] h-2 left-0 ml-3 top-full" x="0px" y="0px" viewBox="0 0 255 255"
              xml:space="preserve"></svg>
          </div>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="16.2" fill="currentColor" viewBox="0 0 512 512">
          <path
            d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z" />
        </svg>

        <p class="text-base header-font text-ellipsis leading-4 pl-3 z-10" [ngClass]="{ hidden: isMinimized }">
          Practice Operational Hours
        </p>
      </button>

      <button
        class="group relative focus:outline-none flex w-full min-w-0 justify-start hover:text-indigo-500 focus:text-indigo-500 rounded py-2"
        [routerLink]="['/dashboard/configuration/pms-objects']" routerLinkActive="router-link-active"
        [ngClass]="{ 'text-indigo-500': activeRoute[2] === 'pms-objects', 'justify-center': isMinimized }">
        <div class="hidden absolute -left-2 -top-5 w-[100px] justify-center z-20"
          [ngClass]="{ 'group-hover:flex': isMinimized }">
          <div class="bg-[#00000079] text-white w-fit header-font rounded py-1 px-4 right-0 bottom-full">
            PMS Objects
            <svg class="absolute text-[#00000079] h-2 left-0 ml-3 top-full" x="0px" y="0px" viewBox="0 0 255 255"
              xml:space="preserve"></svg>
          </div>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="16.2" fill="currentColor" viewBox="0 0 512 512">
          <path
            d="M64 256V160H224v96H64zm0 64H224v96H64V320zm224 96V320H448v96H288zM448 256H288V160H448v96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
            stroke="currentColor" stroke-width="1.5" />
        </svg>
        <p class="text-base header-font leading-4 pl-3" [ngClass]="{ hidden: isMinimized }">
          PMS Objects
        </p>
      </button>

      <button
        class="group relative focus:outline-none flex w-full min-w-0 justify-start hover:text-indigo-500 focus:text-indigo-500 rounded py-2"
        [routerLink]="['/dashboard/configuration/pms-schema-integrity']" routerLinkActive="router-link-active"
        [ngClass]="{ 'text-indigo-500': activeRoute[2] === 'pms-schema-integrity', 'justify-center': isMinimized }">
        <div class="hidden absolute -left-2 -top-5 w-[150px] justify-center z-20"
          [ngClass]="{ 'group-hover:flex': isMinimized }">
          <div class="bg-[#00000079] text-white w-fit header-font rounded py-1 px-4 right-0 bottom-full">
            PMS Schema Integrity
            <svg class="absolute text-[#00000079] h-2 left-0 ml-3 top-full" x="0px" y="0px" viewBox="0 0 255 255"
              xml:space="preserve"></svg>
          </div>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="16.2" fill="currentColor" viewBox="0 0 512 512">
          <path
            d="M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0zm0 66.8V444.8C394 378 431.1 230.1 432 141.4L256 66.8l0 0z"
            stroke="currentColor" stroke-width="1.5" />
        </svg>
        <p class="text-base header-font leading-4 pl-3" [ngClass]="{ hidden: isMinimized }">
          PMS Schema Integrity
        </p>
      </button>

      <button
        class="group relative focus:outline-none flex w-full min-w-0 justify-start hover:text-indigo-500 focus:text-indigo-500 rounded py-2"
        [routerLink]="['/dashboard/configuration/phi-records']" routerLinkActive="router-link-active"
        [ngClass]="{ 'text-indigo-500': activeRoute[2] === 'phi-records', 'justify-center': isMinimized }">
        <div class="hidden absolute -left-2 -top-5 w-[100px] justify-center z-20"
          [ngClass]="{ 'group-hover:flex': isMinimized }">
          <div class="bg-[#00000079] text-white w-fit header-font rounded py-1 px-4 right-0 bottom-full">
            PHI Records
            <svg class="absolute text-[#00000079] h-2 left-0 ml-3 top-full" x="0px" y="0px" viewBox="0 0 255 255"
              xml:space="preserve"></svg>
          </div>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="16.2" fill="currentColor" viewBox="0 0 576 512">
          <path
            d="M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v47l-92.8 37.1c-21.3 8.5-35.2 29.1-35.2 52c0 56.6 18.9 148 94.2 208.3c-9 4.8-19.3 7.6-30.2 7.6H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm39.1 97.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8V461.7c68.2-33 91.5-99 95.4-149.7z" />
        </svg>

        <p class="text-base header-font leading-4 pl-3" [ngClass]="{ hidden: isMinimized }">
          PHI Records
        </p>
      </button>

      <!-- Load Schedule -->
      <button
        class="group relative focus:outline-none flex w-full min-w-0 justify-start hover:text-indigo-500 focus:text-indigo-500 rounded py-2"
        [routerLink]="['/dashboard/configuration/load-schedules']" routerLinkActive="router-link-active" [ngClass]="{
          'text-indigo-500': activeRoute[2] === 'load-schedules',
          'justify-center': isMinimized
        }">
        <div class="hidden absolute -left-12 -top-5 w-[200px] justify-center z-20"
          [ngClass]="{ 'group-hover:flex': isMinimized }">
          <div class="bg-[#00000079] text-white w-fit header-font rounded py-1 px-4 right-0 bottom-full">
            Load Schedules
            <svg class="absolute text-[#00000079] h-2 left-0 ml-3 top-full" x="0px" y="0px" viewBox="0 0 255 255"
              xml:space="preserve"></svg>
          </div>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="16.2" fill="currentColor" viewBox="0 0 448 512">
          <path
            d="M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H336zM64 400v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z" />
        </svg>

        <p class="text-base header-font leading-4 pl-3" [ngClass]="{ hidden: isMinimized }">
          Load Schedules
        </p>
      </button>

      <button
        class="group relative focus:outline-none flex w-full min-w-0 justify-start hover:text-indigo-500 focus:text-indigo-500 rounded py-2"
        [routerLink]="['/dashboard/configuration/practice-load-configurations']" routerLinkActive="router-link-active"
        [ngClass]="{
          'text-indigo-500': activeRoute[2] === 'practice-load-configurations',
          'justify-center': isMinimized
        }">
        <div class="hidden absolute -left-6 -top-5 w-[200px] justify-center z-20"
          [ngClass]="{ 'group-hover:flex': isMinimized }">
          <div class="bg-[#00000079] text-white w-fit header-font rounded py-1 px-4 right-0 bottom-full">
            Practice Load Configurations
            <svg class="absolute text-[#00000079] h-2 left-0 ml-3 top-full" x="0px" y="0px" viewBox="0 0 255 255"
              xml:space="preserve"></svg>
          </div>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="16.2" fill="currentColor" viewBox="0 0 512 512">
          <path
            d="M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z" />
        </svg>

        <p class="text-base header-font text-ellipsis leading-4 pl-3 z-10" [ngClass]="{ hidden: isMinimized }">
          Practice Load Configurations
        </p>
      </button>

      <button
        class="group relative focus:outline-none flex w-full min-w-0 justify-start hover:text-indigo-500 focus:text-indigo-500 rounded py-2"
        [routerLink]="['/dashboard/configuration/dentrix-adjustment-types']" routerLinkActive="router-link-active"
        [ngClass]="{ 'text-indigo-500': activeRoute[2] === 'dentrix-adjustment-types', 'justify-center': isMinimized }">
        <div class="hidden absolute -left-12 -top-5 w-[220px] justify-center z-20"
          [ngClass]="{ 'group-hover:flex': isMinimized }">
          <div class="bg-[#00000079] text-white w-fit header-font rounded py-1 px-4 right-0 bottom-full">
            Dentrix Adjustment Types
            <svg class="absolute text-[#00000079] h-2 left-0 ml-3 top-full" x="0px" y="0px" viewBox="0 0 255 255"
              xml:space="preserve"></svg>
          </div>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="16.2" fill="currentColor" viewBox="0 0 512 512">
          <path
            d="M256 48c-114.9 0-208 93.1-208 208s93.1 208 208 208s208-93.1 208-208S370.9 48 256 48zm0 80c44.2 0 80 35.8 80 80c0 29.8-16.3 55.8-40.5 69.7l47.2 94.5c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L238.3 306H224c-17.7 0-32-14.3-32-32V208c0-44.2 35.8-80 80-80z" />
        </svg>
        <p class="text-base header-font text-ellipsis leading-4 pl-3 z-10" [ngClass]="{ hidden: isMinimized }">
          Dentrix Adjustment Types
        </p>
      </button>

    </div>
  </div>

  <!-- Reports Menu-->

  <div class="flex flex-col justify-start px-3 pb-2 w-full text-gray-600" [ngClass]="{ 'items-center': isMinimized }">
    <div class="relative group">
      <button
        class="overflow-hidden hover:bg-gray-100 focus:bg-gray-100 px-3 focus:outline-none text-left flex min-w-0 w-full justify-between items-center py-2 gap-2"
        [ngClass]="{
          '!text-indigo-500 !bg-indigo-100': activeRoute[1] == 'reports',
          'w-fit': isMinimized,
          'w-full': !isMinimized
        }" (click)="toggleReportsMenu()">
        <span class="flex gap-3 items-center">
          <svg xmlns="http://www.w3.org/2000/svg" height="16.2" width="16.5" fill="currentColor" viewBox="0 0 512 512">
            <path
              d="M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32zm32 64H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32z" />
          </svg>
          <p class="text-base header-font leading-5" [ngClass]="{ hidden: isMinimized }">
            Reports
          </p>
        </span>

        <svg id="icon1" class="transform" [ngClass]="{ hidden: isMinimized, 'rotate-180': !reportsMenu }" width="16.5"
          height="16.2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 15L12 9L6 15" stroke="currentColor" stroke-width="3" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
      <!-- Tooltip for Reports -->
      <div
        class="hidden absolute -left-2 -top-5 w-[100px] justify-center transition-opacity duration-700 ease-in-out opacity z-20"
        [ngClass]="{ 'group-hover:flex': isMinimized }">
        <div class="bg-[#00000079] text-white w-fit header-font rounded py-1 px-4 right-0 bottom-full">
          Reports
          <svg class="absolute text-[#00000079] h-2 left-0 ml-3 top-full" x="0px" y="0px" viewBox="0 0 255 255"
            xml:space="preserve"></svg>
        </div>
      </div>
    </div>
    <div id="menu2" class="flex w-full min-w-0 flex-col pt-1 text-gray-600" [class]="reportsMenu ? 'flex' : 'hidden'"
      [ngClass]="{
        'items-center': isMinimized,
        'pl-0': isMinimized,
        'pl-6 ': !isMinimized,
        'w-[60%]': isMinimized
      }">
      <button
        class="group relative focus:outline-none flex w-full min-w-0 justify-start hover:text-indigo-500 focus:text-indigo-500 rounded py-2"
        [routerLink]="['/dashboard/reports/practice-installation-logs']" routerLinkActive="router-link-active"
        [ngClass]="{
          'text-indigo-500': activeRoute[2] === 'practice-installation-logs',
          'justify-center': isMinimized
        }">
        <div class="hidden absolute -left-6 -top-5 w-[200px] justify-center z-20"
          [ngClass]="{ 'group-hover:flex': isMinimized }">
          <div class="bg-[#00000079] text-white w-fit header-font rounded py-1 px-4 right-0 bottom-full">
            Practice Installation Logs
            <svg class="absolute text-[#00000079] h-2 left-0 ml-3 top-full" x="0px" y="0px" viewBox="0 0 255 255"
              xml:space="preserve"></svg>
          </div>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="16.2" fill="currentColor" viewBox="0 0 384 512">
          <path
            d="M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM72 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zM72 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16z" />
        </svg>

        <p class="text-base header-font text-ellipsis leading-4 pl-3 z-10" [ngClass]="{ hidden: isMinimized }">
          Practice Installation Logs
        </p>
      </button>

      <button
        class="group relative focus:outline-none flex w-full min-w-0 justify-start hover:text-indigo-500 focus:text-indigo-500 rounded py-2"
        [routerLink]="['/dashboard/reports/pms-agent-health-status']" routerLinkActive="router-link-active" [ngClass]="{
          'text-indigo-500': activeRoute[2] === 'pms-agent-health-status',
          'justify-center': isMinimized
        }">
        <svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="16.2" fill="currentColor" viewBox="0 0 512 512">
          <path
            d="M256 48a208 208 0 1 1 0 416A208 208 0 1 1 256 48zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z" />
        </svg>
        <p class="text-base header-font text-ellipsis leading-4 pl-3 z-10" [ngClass]="{ hidden: isMinimized }">
          PMS Agent Health Status
        </p>
      </button>

      <button
        class="group relative focus:outline-none flex w-full min-w-0 justify-start hover:text-indigo-500 focus:text-indigo-500 rounded py-2"
        [routerLink]="['/dashboard/reports/practice-error-logs']" routerLinkActive="router-link-active" [ngClass]="{
          'text-indigo-500': activeRoute[2] === 'practice-error-logs',
          'justify-center': isMinimized
        }">
        <svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="16.2" fill="currentColor" viewBox="0 0 512 512">
          <path
            d="M256 48a208 208 0 1 1 0 416A208 208 0 1 1 256 48zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z" />
        </svg>
        <p class="text-base header-font text-ellipsis leading-4 pl-3 z-10" [ngClass]="{ hidden: isMinimized }">
          Practice Error Logs
        </p>
      </button>

      <button
        class="group relative focus:outline-none flex w-full min-w-0 justify-start hover:text-indigo-500 focus:text-indigo-500 rounded py-2"
        [routerLink]="['/dashboard/reports/practice-load-summary']" routerLinkActive="router-link-active" [ngClass]="{
          'text-indigo-500': activeRoute[2] === 'practice-load-summary',
          'justify-center': isMinimized
        }">
        <svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="16.2" fill="currentColor" viewBox="0 0 512 512">
          <path
            d="M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 0v64h64V96H64zm384 0H192v64H448V96zM64 224v64h64V224H64zm384 0H192v64H448V224zM64 352v64h64V352H64zm384 0H192v64H448V352z" />
        </svg>
        <p class="text-base header-font text-ellipsis leading-4 pl-3 z-10" [ngClass]="{ hidden: isMinimized }">
          Practice Load Summary
        </p>
      </button>

      <button *ngIf="this.userRole == 'SUPER ADMIN'"
        class="group relative focus:outline-none flex w-full min-w-0 justify-start hover:text-indigo-500 focus:text-indigo-500 rounded py-2"
        [routerLink]="['/dashboard/reports/user-logs']" routerLinkActive="router-link-active" [ngClass]="{
          'text-indigo-500': activeRoute[2] === 'user-logs',
          'justify-center': isMinimized
        }">
        <svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="16.2" fill="currentColor" viewBox="0 0 448 512">
          <path
            d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z" />
        </svg>
        <p class="text-base header-font text-ellipsis leading-4 pl-3 z-10" [ngClass]="{ hidden: isMinimized }">
          User Login History
        </p>
      </button>

      <button *ngIf="this.userRole == 'SUPER ADMIN'"
        class="group relative focus:outline-none flex w-full min-w-0 justify-start hover:text-indigo-500 focus:text-indigo-500 rounded py-2"
        [routerLink]="['/dashboard/reports/audit-report']" routerLinkActive="router-link-active" [ngClass]="{
          'text-indigo-500': activeRoute[2] === 'audit-report',
          'justify-center': isMinimized
        }">
        <svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="16.2" fill="currentColor" viewBox="0 0 576 512">
          <path
            d="M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V288H216c-13.3 0-24 10.7-24 24s10.7 24 24 24H384v48c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM558.3 241.9c6.1 6.5 5.8 16.7-.7 22.8l-96 90c-6.3 5.9-16.1 5.9-22.4-.1l-48-45c-6.4-6-6.8-16.1-.8-22.6s16.1-6.8 22.6-.8l36.9 34.6 84.8-79.6c6.5-6.1 16.7-5.8 22.8 .7z" />
        </svg>
        <p class="text-base header-font text-ellipsis leading-4 pl-3 z-10" [ngClass]="{ hidden: isMinimized }">
          Audit Report
        </p>
      </button>

      <button
        class="group relative focus:outline-none flex w-full min-w-0 justify-start hover:text-indigo-500 focus:text-indigo-500 rounded py-2"
        [routerLink]="['/dashboard/reports/last-seven-days-load']" routerLinkActive="router-link-active" [ngClass]="{
          'text-indigo-500': activeRoute[2] === 'last-seven-days-load',
          'justify-center': isMinimized
        }">
        <svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="16.2" fill="currentColor" viewBox="0 0 448 512">
          <path
            d="M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm80 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80zm144 0c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H224z" />
        </svg>
        <p class="text-base header-font text-ellipsis leading-4 pl-3 z-10" [ngClass]="{ hidden: isMinimized }">
          Last 7 Days Data Load
        </p>
      </button>

      <button
        class="group relative focus:outline-none flex w-full min-w-0 justify-start hover:text-indigo-500 focus:text-indigo-500 rounded py-2"
        [routerLink]="['/dashboard/reports/daily-load-volume-trend']" routerLinkActive="router-link-active" [ngClass]="{
          'text-indigo-500': activeRoute[2] === 'daily-load-volume-trend',
          'justify-center': isMinimized
        }">
        <svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="16.2" fill="currentColor" viewBox="0 0 512 512">
          <path
            d="M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z" />
        </svg>
        <p class="text-base header-font text-ellipsis leading-4 pl-3 z-10" [ngClass]="{ hidden: isMinimized }">
          Daily Load Volume Trend
        </p>
      </button>

      <button
        class="group relative focus:outline-none flex w-full min-w-0 justify-start hover:text-indigo-500 focus:text-indigo-500 rounded py-2"
        [routerLink]="['/dashboard/reports/net-production-report']" routerLinkActive="router-link-active" [ngClass]="{
          'text-indigo-500': activeRoute[2] === 'net-production-report',
          'justify-center': isMinimized
        }">
        <div class="hidden absolute -left-12 -top-5 w-[200px] justify-center z-20"
          [ngClass]="{ 'group-hover:flex': isMinimized }">
          <div class="bg-[#00000079] text-white w-fit header-font rounded py-1 px-4 right-0 bottom-full">
            Net Production Report
          </div>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="16.2" fill="currentColor" viewBox="0 0 512 512">
          <path
            d="M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z" />
        </svg>
        <p class="text-base header-font text-ellipsis leading-4 pl-3 z-10" [ngClass]="{ hidden: isMinimized }">
          Net Production Report
        </p>
      </button>

      <button
        class="group relative focus:outline-none flex w-full min-w-0 justify-start hover:text-indigo-500 focus:text-indigo-500 rounded py-2"
        [routerLink]="['/dashboard/reports/net-collection-report']" routerLinkActive="router-link-active" [ngClass]="{
          'text-indigo-500': activeRoute[2] === 'net-collection-report',
          'justify-center': isMinimized
        }">
        <div class="hidden absolute -left-12 -top-5 w-[200px] justify-center z-20"
          [ngClass]="{ 'group-hover:flex': isMinimized }">
          <div class="bg-[#00000079] text-white w-fit header-font rounded py-1 px-4 right-0 bottom-full">
            Net Collection Report
          </div>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="16.2" fill="currentColor" viewBox="0 0 512 512">
          <path
            d="M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 0v64h64V96H64zm384 0H192v64H448V96zM64 224v64h64V224H64zm384 0H192v64H448V224zM64 352v64h64V352H64zm384 0H192v64H448V352z" />
        </svg>
        <p class="text-base header-font text-ellipsis leading-4 pl-3 z-10" [ngClass]="{ hidden: isMinimized }">
          Net Collection Report
        </p>
      </button>
    </div>
  </div>

  <!-- Release Menu -->
  <div class="flex flex-col justify-start px-3 pb-2 w-full text-gray-600" [ngClass]="{ 'items-center': isMinimized }">
    <div class="relative group">
      <button
        class="overflow-hidden hover:bg-gray-100 focus:bg-gray-100 px-3 focus:outline-none text-left flex min-w-0 w-full justify-between items-center py-2 gap-2"
        [ngClass]="{
          '!text-indigo-500 !bg-indigo-100':
            activeRoute[1] == 'manage-agent-releases',
          'w-fit': isMinimized,
          'w-full': !isMinimized
        }" (click)="toggleAgentReleaseMenu()">
        <span class="flex items-center gap-3 min-w-0">
          <svg xmlns="http://www.w3.org/2000/svg" height="16.2" width="16.2" fill="currentColor" viewBox="0 0 640 512">
            <path
              d="M160 64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H336.8c-11.8-25.5-29.9-47.5-52.4-64H384V320c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v32h64V64L224 64v49.1C205.2 102.2 183.3 96 160 96V64zm0 64a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM133.3 352h53.3C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3C0 411.7 59.7 352 133.3 352z" />
          </svg>
          <p class="text-base header-font leading-5 text-ellipsis min-w-0" [ngClass]="{ hidden: isMinimized }">
            Manage PMS Agent releases
          </p>
        </span>
        <svg id="icon1" class="transform" [ngClass]="{ 'rotate-180': !agentReleaseMenu, hidden: isMinimized }"
          width="16.5" height="16.2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 15L12 9L6 15" stroke="currentColor" stroke-width="3" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
      <!-- Tooltip for Manage PMS Agent releases -->
      <div
        class="hidden absolute -left-0 -top-15 w-[150px] justify-center transition-opacity duration-700 ease-in-out opacity z-20"
        [ngClass]="{ 'group-hover:flex': isMinimized }">
        <div class="bg-[#00000079] text-white w-fit header-font rounded py-1 px-4 right-0 bottom-full">
          Manage PMS Agent releases
          <svg class="absolute text-[#00000079] h-2 left-0 ml-3 top-full" x="0px" y="0px" viewBox="0 0 255 255"
            xml:space="preserve"></svg>
        </div>
      </div>
    </div>
    <div id="menu2" class="flex w-full min-w-0 flex-col pt-1 text-gray-600"
      [class]="agentReleaseMenu ? 'flex' : 'hidden'" [ngClass]="{
        'items-center': isMinimized,
        'pl-0': isMinimized,
        'pl-6 ': !isMinimized,
        'w-[60%]': isMinimized
      }">
      <!-- PMS Agent Release -->
      <button
        class="group relative focus:outline-none flex w-full min-w-0 justify-start hover:text-indigo-500 focus:text-indigo-500 rounded py-2"
        [routerLink]="['/dashboard/manage-agent-releases/configure']" routerLinkActive="router-link-active" [ngClass]="{
          'text-indigo-500': activeRoute[2] === 'configure',
          'justify-center': isMinimized
        }">
        <div class="hidden absolute -left-12 -top-5 w-[200px] justify-center z-20"
          [ngClass]="{ 'group-hover:flex': isMinimized }">
          <div class="bg-[#00000079] text-white w-fit header-font rounded py-1 px-4 right-0 bottom-full">
            Configure Releases
            <svg class="absolute text-[#00000079] h-2 left-0 ml-3 top-full" x="0px" y="0px" viewBox="0 0 255 255"
              xml:space="preserve"></svg>
          </div>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="16.2" fill="currentColor" viewBox="0 0 640 512">
          <path
            d="M58.9 42.1c3-6.1 9.6-9.6 16.3-8.7L320 64 564.8 33.4c6.7-.8 13.3 2.7 16.3 8.7l41.7 83.4c9 17.9-.6 39.6-19.8 45.1L439.6 217.3c-13.9 4-28.8-1.9-36.2-14.3L320 64 236.6 203c-7.4 12.4-22.3 18.3-36.2 14.3L37.1 170.6c-19.3-5.5-28.8-27.2-19.8-45.1L58.9 42.1zM321.1 128l54.9 91.4c14.9 24.8 44.6 36.6 72.5 28.6L576 211.6v167c0 22-15 41.2-36.4 46.6l-204.1 51c-10.2 2.6-20.9 2.6-31 0l-204.1-51C79 419.7 64 400.5 64 378.5v-167L191.6 248c27.8 8 57.6-3.8 72.5-28.6L318.9 128h2.2z" />
        </svg>

        <p class="text-base header-font leading-4 pl-3" [ngClass]="{ hidden: isMinimized }">
          Configure Releases
        </p>
      </button>

      <!-- PMS Agent Release Mapping -->
      <button
        class="group relative focus:outline-none flex w-full min-w-0 justify-start hover:text-indigo-500 focus:text-indigo-500 rounded pt-2 pb-1"
        [routerLink]="['/dashboard/manage-agent-releases/assign']" routerLinkActive="router-link-active" [ngClass]="{
          'text-indigo-500': activeRoute[2] === 'assign',
          'justify-center': isMinimized
        }">
        <div class="hidden absolute -left-12 -top-5 w-[200px] justify-center z-20"
          [ngClass]="{ 'group-hover:flex': isMinimized }">
          <div class="bg-[#00000079] text-white w-fit header-font rounded py-1 px-4 right-0 bottom-full">
            Assign Releases
            <svg class="absolute text-[#00000079] h-2 left-0 ml-3 top-full" x="0px" y="0px" viewBox="0 0 255 255"
              xml:space="preserve"></svg>
          </div>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="16.2" fill="currentColor" viewBox="0 0 640 512">
          <path
            d="M256 48c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H381.3c1.8-5 2.7-10.4 2.7-16V253.3c18.6-6.6 32-24.4 32-45.3V176c0-26.5-21.5-48-48-48H256V48zM571.3 347.3c6.2-6.2 6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 310.6V432c0 8.8 7.2 16 16 16s16-7.2 16-16V310.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0zM0 176c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V176zm352 80V480c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V256H352zM144 320c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z" />
        </svg>

        <p class="text-base header-font leading-4 pl-3 text-ellipsis" [ngClass]="{ hidden: isMinimized }">
          Assign Releases
        </p>
      </button>
    </div>
  </div>

  <!-- User Role Management -->
  <div class="flex flex-col justify-start px-3 pb-2 w-full text-gray-600" [ngClass]="{ 'items-center': isMinimized }"
    *ngIf="this.userRole == 'SUPER ADMIN'">
    <div class="relative group">
      <!-- Add a relative container for the button and tooltip -->
      <button [routerLink]="['/dashboard/user-role-management']" routerLinkActive="router-link-active"
        class="overflow-hidden hover:bg-gray-100 focus:bg-gray-100 px-3 focus:outline-none text-left flex min-w-0 w-full justify-between items-center py-2 gap-2"
        [ngClass]="{
          '!text-indigo-500 !bg-indigo-100':
            activeRoute[1] == 'user-role-management',
          'w-fit': isMinimized,
          'w-full': !isMinimized
        }">
        <span class="flex gap-3 items-center">
          <svg xmlns="http://www.w3.org/2000/svg" height="16.2" width="16.5" fill="currentColor" viewBox="0 0 640 512">
            <path
              d="M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7H106.7C47.8 192 0 239.8 0 298.7zM320 320c24 0 45.9-8.8 62.7-23.3c2.5-3.7 5.2-7.3 8-10.7c2.7-3.3 5.7-6.1 9-8.3C410 262.3 416 243.9 416 224c0-53-43-96-96-96s-96 43-96 96s43 96 96 96zm65.4 60.2c-10.3-5.9-18.1-16.2-20.8-28.2H261.3C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H455.2c-2.1-5.2-3.2-10.9-3.2-16.4v-3c-1.3-.7-2.7-1.5-4-2.3l-2.6 1.5c-16.8 9.7-40.5 8-54.7-9.7c-4.5-5.6-8.6-11.5-12.4-17.6l-.1-.2-.1-.2-2.4-4.1-.1-.2-.1-.2c-3.4-6.2-6.4-12.6-9-19.3c-8.2-21.2 2.2-42.6 19-52.3l2.7-1.5c0-.8 0-1.5 0-2.3s0-1.5 0-2.3l-2.7-1.5zM533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 17.4-3.5 33.9-9.7 49c2.5 .9 4.9 2 7.1 3.3l2.6 1.5c1.3-.8 2.6-1.6 4-2.3v-3c0-19.4 13.3-39.1 35.8-42.6c7.9-1.2 16-1.9 24.2-1.9s16.3 .6 24.2 1.9c22.5 3.5 35.8 23.2 35.8 42.6v3c1.3 .7 2.7 1.5 4 2.3l2.6-1.5c16.8-9.7 40.5-8 54.7 9.7c2.3 2.8 4.5 5.8 6.6 8.7c-2.1-57.1-49-102.7-106.6-102.7zm91.3 163.9c6.3-3.6 9.5-11.1 6.8-18c-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5c-4.6-5.7-12.7-6.7-19-3l-2.9 1.7c-9.2 5.3-20.4 4-29.6-1.3s-16.1-14.5-16.1-25.1v-3.4c0-7.3-4.9-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4 .5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9v3.4c0 10.6-6.9 19.8-16.1 25.1s-20.4 6.6-29.6 1.3l-2.9-1.7c-6.3-3.6-14.4-2.6-19 3c-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9c-2.6 6.8 .5 14.3 6.8 17.9l2.9 1.7c9.2 5.3 13.7 15.8 13.7 26.4s-4.5 21.1-13.7 26.4l-3 1.7c-6.3 3.6-9.5 11.1-6.8 17.9c2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3 5.1 6.4 9.9 10.1 14.5c4.6 5.7 12.7 6.7 19 3l2.9-1.7c9.2-5.3 20.4-4 29.6 1.3s16.1 14.5 16.1 25.1v3.4c0 7.3 4.9 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9v-3.4c0-10.6 6.9-19.8 16.1-25.1s20.4-6.6 29.6-1.3l2.9 1.7c6.3 3.6 14.4 2.6 19-3c3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8c2.6-6.8-.5-14.3-6.8-17.9l-3-1.7c-9.2-5.3-13.7-15.8-13.7-26.4s4.5-21.1 13.7-26.4l3-1.7zM472 384a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z" />
          </svg>

          <p class="text-base header-font leading-5 text-ellipsis min-w-0" [ngClass]="{ hidden: isMinimized }">
            User Role Management
          </p>
        </span>
      </button>
      <!-- Tooltip for User Role Management -->
      <div
        class="hidden absolute -left-0 -top-15 w-[150px] justify-center transition-opacity duration-700 ease-in-out opacity z-20"
        [ngClass]="{ 'group-hover:flex': isMinimized }">
        <div class="bg-[#00000079] text-white w-fit header-font rounded py-1 px-4 right-0 bottom-full">
          User Role Management
          <svg class="absolute text-[#00000079] h-2 left-0 ml-3 top-full" x="0px" y="0px" viewBox="0 0 255 255"
            xml:space="preserve"></svg>
        </div>
      </div>
    </div>
  </div>

  <!-- System Administration -->
  <div class="flex flex-col justify-start px-3 pb-2 w-full text-gray-600" [ngClass]="{ 'items-center': isMinimized }"
    *ngIf="this.userRole == 'SUPER ADMIN' || this.userRole == 'ADMIN'">
    <div class="relative group">
      <button
        class="overflow-hidden hover:bg-gray-100 focus:bg-gray-100 px-3 focus:outline-none text-left flex min-w-0 w-full justify-between items-center py-2 gap-2"
        [ngClass]="{
          '!text-indigo-500 !bg-indigo-100':
            activeRoute[1] == 'system-administration',
          'w-fit': isMinimized,
          'w-full': !isMinimized
        }" (click)="toggleSystemAdministration()">
        <span class="flex items-center gap-3 min-w-0">
          <svg xmlns="http://www.w3.org/2000/svg" height="16.2" width="16.2" fill="currentColor" viewBox="0 0 640 512">
            <path
              d="M160 64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H336.8c-11.8-25.5-29.9-47.5-52.4-64H384V320c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v32h64V64L224 64v49.1C205.2 102.2 183.3 96 160 96V64zm0 64a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM133.3 352h53.3C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3C0 411.7 59.7 352 133.3 352z" />
          </svg>
          <p class="text-base header-font leading-5 text-ellipsis min-w-0" [ngClass]="{ hidden: isMinimized }">
            System Administration
          </p>
        </span>
        <svg id="icon1" class="transform" [ngClass]="{ 'rotate-180': !systemAdministratioMenu, hidden: isMinimized }"
          width="16.5" height="16.2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 15L12 9L6 15" stroke="currentColor" stroke-width="3" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
      <!-- Tooltip for System Administration -->
      <div
        class="hidden absolute -left-0 -top-15 w-[150px] justify-center transition-opacity duration-700 ease-in-out opacity z-20"
        [ngClass]="{ 'group-hover:flex': isMinimized }">
        <div class="bg-[#00000079] text-white w-fit header-font rounded py-1 px-4 right-0 bottom-full">
          System Administration
          <svg class="absolute text-[#00000079] h-2 left-0 ml-3 top-full" x="0px" y="0px" viewBox="0 0 255 255"
            xml:space="preserve"></svg>
        </div>
      </div>
    </div>
    <div id="menu2" class="flex w-full min-w-0 flex-col pt-1 text-gray-600"
      [class]="systemAdministratioMenu ? 'flex' : 'hidden'" [ngClass]="{
        'items-center': isMinimized,
        'pl-0': isMinimized,
        'pl-6 ': !isMinimized,
        'w-[60%]': isMinimized
      }">

      <!-- Backup Monitor -->
      <button
        class="group relative focus:outline-none flex w-full min-w-0 justify-start hover:text-indigo-500 focus:text-indigo-500 rounded py-2"
        [routerLink]="['/dashboard/system-administration/backup-monitor']" routerLinkActive="router-link-active"
        [ngClass]="{ 'text-indigo-500': activeRoute[2] === 'backup-monitor', 'justify-center': isMinimized }"
        *ngIf="this.userRole == 'SUPER ADMIN' || this.userRole == 'ADMIN'">
        <div class="hidden absolute -left-12 -top-5 w-[200px] justify-center z-20"
          [ngClass]="{ 'group-hover:flex': isMinimized }">
          <div class="bg-[#00000079] text-white w-fit header-font rounded py-1 px-4 right-0 bottom-full">
            Backup Monitor
            <svg class="absolute text-[#00000079] h-2 left-0 ml-3 top-full" x="0px" y="0px" viewBox="0 0 255 255"
              xml:space="preserve"></svg>
          </div>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="16.2" fill="currentColor" viewBox="0 0 512 512">
          <path
            d="M288 109.3V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM64 352H192c0 35.3 28.7 64 64 64s64-28.7 64-64H448c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V416c0-35.3 28.7-64 64-64zM432 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z" />
        </svg>
        <p class="text-base header-font leading-4 pl-3" [ngClass]="{ hidden: isMinimized }">
          Backup Monitor
        </p>
      </button>

      <!-- Clear Server Cache -->
      <button type="button"
        class="group relative focus:outline-none flex justify-start hover:text-indigo-500 focus:text-indigo-500 rounded py-2 disabled:opacity-50 disabled:cursor-not-allowed"
        (click)="clearServerCache()" [disabled]="isClearing" aria-label="Clear Server Cache">
        <!-- Tooltip (only when minimized) -->
        <div class="hidden absolute -left-12 -top-5 w-[200px] justify-center z-20"
          [ngClass]="{ 'group-hover:flex': isMinimized }">
          <div class="bg-[#00000079] text-white w-fit header-font rounded py-1 px-4 right-0 bottom-full">
            Clear Server Cache
            <svg class="absolute text-[#00000079] h-2 left-0 ml-3 top-full" x="0px" y="0px" viewBox="0 0 255 255"
              xml:space="preserve"></svg>
          </div>
        </div>

        <!-- Icon -->
        <svg width="16px" height="16px" viewBox="0 0 48 48" id="b" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <style>
              .t {
                fill: none;
                stroke: #000000;
                stroke-linecap: round;
                stroke-linejoin: round;
              }
            </style>
          </defs>
          <circle id="c" class="t" cx="36.096" cy="22.6536" r="1.3931" />
          <circle id="d" class="t" cx="40.2225" cy="26.8135" r="1.6717" />
          <path id="e" class="t" d="m12.2134,10.4649l11.3032,1.9794" />
          <path id="f" class="t" d="m15.5471,14.4757l7.3445,1.3022" />
          <path id="g" class="t" d="m13.4115,17.3406l8.9592,1.5627" />
          <path id="h" class="t"
            d="m28.9503,31.9961l-.2768-3.4044c-.6946-4.6049-6.0126-5.7231-7.657-1.2762-1.8215,3.7646-8.3136,7.2818-15.4182,8.1518,2.8623,9.2457,18.1701,7.426,20.2625,4.7401" />
          <path id="i" class="t"
            d="m26.9545,34.7903c-4.9816,2.8272-.2458,7.5687,2.6044,5.7297,2.0714,2.7765,6.4689,2.2491,7.5008.1563,5.8857,2.6255,7.2368-5.5731,2.3961-6.3027-1.076-3.7607-4.9677-4.4122-7.2924-2.1356-1.9877-.4898-4.0291-1.2665-5.2089,2.5524Z" />
          <path id="j" class="t" d="m9.2965,17.4072v1.5105" />
          <path id="k" class="t" d="m9.2965,21.2702v1.5106" />
          <path id="l" class="t" d="m10.5248,20.094l1.5105.0522" />
          <path id="m" class="t" d="m6.6618,20.1461h1.5106" />
          <path id="n" class="t"
            d="m14.0712,27.9419l1.0313,1.105m0-3.8734l-1.0682,1.0681m-2.7315-.9945l1.0681,1.0681m0,1.5898l-1.0681,1.0682" />
          <path id="o" class="t" d="m21.0164,27.3156c2.3279,1.9405,4.9381,1.9753,7.657,1.2762" />
          <path id="p" class="t" d="m10.9776,41.135c5.6948-1.9298,9.2192-4.403,11.1848-7.2823" />
          <path id="q" class="t" d="m22.1103,38.4886c-1.116,1.5442-2.4716,2.8254-4.7661,3.8785" />
          <path id="r" class="t" d="m7.1015,38.3102c3.2416-.0909,5.7762-1.2165,8.2373-2.4782" />
          <path id="s" class="t"
            d="m23.712,24.6163l3.2165-17.1726c.448-2.9721,3.9476-2.1183,3.2685.573l-3.3643,17.2741" />
        </svg>

        <!-- Label (hidden when minimized) -->
        <p class="text-base header-font leading-4 pl-3" [ngClass]="{ hidden: isMinimized }">
          Clear Server Cache
          <span *ngIf="isClearing" class="ml-2 text-xs">(workingâ€¦)</span>
        </p>
      </button>

    </div>
  </div>
</aside>

<div *ngIf="isLoading" class="full-screen-loader">
  <div class="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-indigo-500 !important"></div>
</div>

<app-confirmation-modal [isVisible]="isClearCacheConfirmationModalVisible"
  (onActionEventEmitter)="handleClearCacheModalAction($event)" [title]="'Clear Server Cache'"
  [message]="'Are you sure you want to clear the server cache?'"></app-confirmation-modal>

<app-toast></app-toast>